/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root.lazy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UnauthorizedIndexRouteImport } from './routes/unauthorized/index'
import { Route as StudiesIndexRouteImport } from './routes/studies/index'
import { Route as SamplesIndexRouteImport } from './routes/samples/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as InstrumentsIndexRouteImport } from './routes/instruments/index'
import { Route as Instrument_runsIndexRouteImport } from './routes/instrument_runs/index'
import { Route as FleetIndexRouteImport } from './routes/fleet/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as StudiesStudyIdRouteImport } from './routes/studies/$studyId'
import { Route as SamplesSampleIdRouteImport } from './routes/samples/$sampleId'
import { Route as OrganizationsNewRouteImport } from './routes/organizations/new'
import { Route as OrganizationsOrgIdRouteImport } from './routes/organizations/$orgId'
import { Route as Instrument_runsNewRouteImport } from './routes/instrument_runs/new'
import { Route as Instrument_runsInstrumentRunIdRouteImport } from './routes/instrument_runs/$instrumentRunId'
import { Route as StudiesStudyIdTauSamplesRouteImport } from './routes/studies/$studyId_.tau-samples'
import { Route as StudiesStudyIdBroadscaleSamplesRouteImport } from './routes/studies/$studyId_.broadscale-samples'

const Not_foundIndexLazyRouteImport = createFileRoute('/not_found/')()
const No_orgIndexLazyRouteImport = createFileRoute('/no_org/')()

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Not_foundIndexLazyRoute = Not_foundIndexLazyRouteImport.update({
  id: '/not_found/',
  path: '/not_found/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/not_found/index.lazy').then((d) => d.Route),
)
const No_orgIndexLazyRoute = No_orgIndexLazyRouteImport.update({
  id: '/no_org/',
  path: '/no_org/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/no_org/index.lazy').then((d) => d.Route))
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedIndexRoute = UnauthorizedIndexRouteImport.update({
  id: '/unauthorized/',
  path: '/unauthorized/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudiesIndexRoute = StudiesIndexRouteImport.update({
  id: '/studies/',
  path: '/studies/',
  getParentRoute: () => rootRouteImport,
} as any)
const SamplesIndexRoute = SamplesIndexRouteImport.update({
  id: '/samples/',
  path: '/samples/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reset-password/index.lazy').then((d) => d.Route),
)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/organizations/index.lazy').then((d) => d.Route),
)
const InstrumentsIndexRoute = InstrumentsIndexRouteImport.update({
  id: '/instruments/',
  path: '/instruments/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/instruments/index.lazy').then((d) => d.Route),
)
const Instrument_runsIndexRoute = Instrument_runsIndexRouteImport.update({
  id: '/instrument_runs/',
  path: '/instrument_runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetIndexRoute = FleetIndexRouteImport.update({
  id: '/fleet/',
  path: '/fleet/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/index.lazy').then((d) => d.Route))
const StudiesStudyIdRoute = StudiesStudyIdRouteImport.update({
  id: '/studies/$studyId',
  path: '/studies/$studyId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/studies/$studyId.lazy').then((d) => d.Route),
)
const SamplesSampleIdRoute = SamplesSampleIdRouteImport.update({
  id: '/samples/$sampleId',
  path: '/samples/$sampleId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/samples/$sampleId.lazy').then((d) => d.Route),
)
const OrganizationsNewRoute = OrganizationsNewRouteImport.update({
  id: '/organizations/new',
  path: '/organizations/new',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/organizations/new.lazy').then((d) => d.Route),
)
const OrganizationsOrgIdRoute = OrganizationsOrgIdRouteImport.update({
  id: '/organizations/$orgId',
  path: '/organizations/$orgId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/organizations/$orgId.lazy').then((d) => d.Route),
)
const Instrument_runsNewRoute = Instrument_runsNewRouteImport.update({
  id: '/instrument_runs/new',
  path: '/instrument_runs/new',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/instrument_runs/new.lazy').then((d) => d.Route),
)
const Instrument_runsInstrumentRunIdRoute =
  Instrument_runsInstrumentRunIdRouteImport.update({
    id: '/instrument_runs/$instrumentRunId',
    path: '/instrument_runs/$instrumentRunId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StudiesStudyIdTauSamplesRoute =
  StudiesStudyIdTauSamplesRouteImport.update({
    id: '/studies/$studyId_/tau-samples',
    path: '/studies/$studyId/tau-samples',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/studies/$studyId_.tau-samples.lazy').then((d) => d.Route),
  )
const StudiesStudyIdBroadscaleSamplesRoute =
  StudiesStudyIdBroadscaleSamplesRouteImport.update({
    id: '/studies/$studyId_/broadscale-samples',
    path: '/studies/$studyId/broadscale-samples',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/studies/$studyId_.broadscale-samples.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/instrument_runs/$instrumentRunId': typeof Instrument_runsInstrumentRunIdRoute
  '/instrument_runs/new': typeof Instrument_runsNewRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/samples/$sampleId': typeof SamplesSampleIdRoute
  '/studies/$studyId': typeof StudiesStudyIdRoute
  '/auth/': typeof AuthIndexRoute
  '/fleet/': typeof FleetIndexRoute
  '/instrument_runs/': typeof Instrument_runsIndexRoute
  '/instruments/': typeof InstrumentsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/samples/': typeof SamplesIndexRoute
  '/studies/': typeof StudiesIndexRoute
  '/unauthorized/': typeof UnauthorizedIndexRoute
  '/users/': typeof UsersIndexRoute
  '/no_org/': typeof No_orgIndexLazyRoute
  '/not_found/': typeof Not_foundIndexLazyRoute
  '/studies/$studyId/broadscale-samples': typeof StudiesStudyIdBroadscaleSamplesRoute
  '/studies/$studyId/tau-samples': typeof StudiesStudyIdTauSamplesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/instrument_runs/$instrumentRunId': typeof Instrument_runsInstrumentRunIdRoute
  '/instrument_runs/new': typeof Instrument_runsNewRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/samples/$sampleId': typeof SamplesSampleIdRoute
  '/studies/$studyId': typeof StudiesStudyIdRoute
  '/auth': typeof AuthIndexRoute
  '/fleet': typeof FleetIndexRoute
  '/instrument_runs': typeof Instrument_runsIndexRoute
  '/instruments': typeof InstrumentsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/samples': typeof SamplesIndexRoute
  '/studies': typeof StudiesIndexRoute
  '/unauthorized': typeof UnauthorizedIndexRoute
  '/users': typeof UsersIndexRoute
  '/no_org': typeof No_orgIndexLazyRoute
  '/not_found': typeof Not_foundIndexLazyRoute
  '/studies/$studyId/broadscale-samples': typeof StudiesStudyIdBroadscaleSamplesRoute
  '/studies/$studyId/tau-samples': typeof StudiesStudyIdTauSamplesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/instrument_runs/$instrumentRunId': typeof Instrument_runsInstrumentRunIdRoute
  '/instrument_runs/new': typeof Instrument_runsNewRoute
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/samples/$sampleId': typeof SamplesSampleIdRoute
  '/studies/$studyId': typeof StudiesStudyIdRoute
  '/auth/': typeof AuthIndexRoute
  '/fleet/': typeof FleetIndexRoute
  '/instrument_runs/': typeof Instrument_runsIndexRoute
  '/instruments/': typeof InstrumentsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/samples/': typeof SamplesIndexRoute
  '/studies/': typeof StudiesIndexRoute
  '/unauthorized/': typeof UnauthorizedIndexRoute
  '/users/': typeof UsersIndexRoute
  '/no_org/': typeof No_orgIndexLazyRoute
  '/not_found/': typeof Not_foundIndexLazyRoute
  '/studies/$studyId_/broadscale-samples': typeof StudiesStudyIdBroadscaleSamplesRoute
  '/studies/$studyId_/tau-samples': typeof StudiesStudyIdTauSamplesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/instrument_runs/$instrumentRunId'
    | '/instrument_runs/new'
    | '/organizations/$orgId'
    | '/organizations/new'
    | '/samples/$sampleId'
    | '/studies/$studyId'
    | '/auth/'
    | '/fleet/'
    | '/instrument_runs/'
    | '/instruments/'
    | '/organizations/'
    | '/reset-password/'
    | '/samples/'
    | '/studies/'
    | '/unauthorized/'
    | '/users/'
    | '/no_org/'
    | '/not_found/'
    | '/studies/$studyId/broadscale-samples'
    | '/studies/$studyId/tau-samples'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/instrument_runs/$instrumentRunId'
    | '/instrument_runs/new'
    | '/organizations/$orgId'
    | '/organizations/new'
    | '/samples/$sampleId'
    | '/studies/$studyId'
    | '/auth'
    | '/fleet'
    | '/instrument_runs'
    | '/instruments'
    | '/organizations'
    | '/reset-password'
    | '/samples'
    | '/studies'
    | '/unauthorized'
    | '/users'
    | '/no_org'
    | '/not_found'
    | '/studies/$studyId/broadscale-samples'
    | '/studies/$studyId/tau-samples'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/instrument_runs/$instrumentRunId'
    | '/instrument_runs/new'
    | '/organizations/$orgId'
    | '/organizations/new'
    | '/samples/$sampleId'
    | '/studies/$studyId'
    | '/auth/'
    | '/fleet/'
    | '/instrument_runs/'
    | '/instruments/'
    | '/organizations/'
    | '/reset-password/'
    | '/samples/'
    | '/studies/'
    | '/unauthorized/'
    | '/users/'
    | '/no_org/'
    | '/not_found/'
    | '/studies/$studyId_/broadscale-samples'
    | '/studies/$studyId_/tau-samples'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  Instrument_runsInstrumentRunIdRoute: typeof Instrument_runsInstrumentRunIdRoute
  Instrument_runsNewRoute: typeof Instrument_runsNewRoute
  OrganizationsOrgIdRoute: typeof OrganizationsOrgIdRoute
  OrganizationsNewRoute: typeof OrganizationsNewRoute
  SamplesSampleIdRoute: typeof SamplesSampleIdRoute
  StudiesStudyIdRoute: typeof StudiesStudyIdRoute
  AuthIndexRoute: typeof AuthIndexRoute
  FleetIndexRoute: typeof FleetIndexRoute
  Instrument_runsIndexRoute: typeof Instrument_runsIndexRoute
  InstrumentsIndexRoute: typeof InstrumentsIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  SamplesIndexRoute: typeof SamplesIndexRoute
  StudiesIndexRoute: typeof StudiesIndexRoute
  UnauthorizedIndexRoute: typeof UnauthorizedIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  No_orgIndexLazyRoute: typeof No_orgIndexLazyRoute
  Not_foundIndexLazyRoute: typeof Not_foundIndexLazyRoute
  StudiesStudyIdBroadscaleSamplesRoute: typeof StudiesStudyIdBroadscaleSamplesRoute
  StudiesStudyIdTauSamplesRoute: typeof StudiesStudyIdTauSamplesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not_found/': {
      id: '/not_found/'
      path: '/not_found'
      fullPath: '/not_found/'
      preLoaderRoute: typeof Not_foundIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no_org/': {
      id: '/no_org/'
      path: '/no_org'
      fullPath: '/no_org/'
      preLoaderRoute: typeof No_orgIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized/': {
      id: '/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof UnauthorizedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/': {
      id: '/studies/'
      path: '/studies'
      fullPath: '/studies/'
      preLoaderRoute: typeof StudiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/samples/': {
      id: '/samples/'
      path: '/samples'
      fullPath: '/samples/'
      preLoaderRoute: typeof SamplesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instruments/': {
      id: '/instruments/'
      path: '/instruments'
      fullPath: '/instruments/'
      preLoaderRoute: typeof InstrumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instrument_runs/': {
      id: '/instrument_runs/'
      path: '/instrument_runs'
      fullPath: '/instrument_runs/'
      preLoaderRoute: typeof Instrument_runsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/': {
      id: '/fleet/'
      path: '/fleet'
      fullPath: '/fleet/'
      preLoaderRoute: typeof FleetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/$studyId': {
      id: '/studies/$studyId'
      path: '/studies/$studyId'
      fullPath: '/studies/$studyId'
      preLoaderRoute: typeof StudiesStudyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/samples/$sampleId': {
      id: '/samples/$sampleId'
      path: '/samples/$sampleId'
      fullPath: '/samples/$sampleId'
      preLoaderRoute: typeof SamplesSampleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/new': {
      id: '/organizations/new'
      path: '/organizations/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof OrganizationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$orgId': {
      id: '/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof OrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instrument_runs/new': {
      id: '/instrument_runs/new'
      path: '/instrument_runs/new'
      fullPath: '/instrument_runs/new'
      preLoaderRoute: typeof Instrument_runsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instrument_runs/$instrumentRunId': {
      id: '/instrument_runs/$instrumentRunId'
      path: '/instrument_runs/$instrumentRunId'
      fullPath: '/instrument_runs/$instrumentRunId'
      preLoaderRoute: typeof Instrument_runsInstrumentRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/$studyId_/tau-samples': {
      id: '/studies/$studyId_/tau-samples'
      path: '/studies/$studyId/tau-samples'
      fullPath: '/studies/$studyId/tau-samples'
      preLoaderRoute: typeof StudiesStudyIdTauSamplesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/$studyId_/broadscale-samples': {
      id: '/studies/$studyId_/broadscale-samples'
      path: '/studies/$studyId/broadscale-samples'
      fullPath: '/studies/$studyId/broadscale-samples'
      preLoaderRoute: typeof StudiesStudyIdBroadscaleSamplesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  Instrument_runsInstrumentRunIdRoute: Instrument_runsInstrumentRunIdRoute,
  Instrument_runsNewRoute: Instrument_runsNewRoute,
  OrganizationsOrgIdRoute: OrganizationsOrgIdRoute,
  OrganizationsNewRoute: OrganizationsNewRoute,
  SamplesSampleIdRoute: SamplesSampleIdRoute,
  StudiesStudyIdRoute: StudiesStudyIdRoute,
  AuthIndexRoute: AuthIndexRoute,
  FleetIndexRoute: FleetIndexRoute,
  Instrument_runsIndexRoute: Instrument_runsIndexRoute,
  InstrumentsIndexRoute: InstrumentsIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  SamplesIndexRoute: SamplesIndexRoute,
  StudiesIndexRoute: StudiesIndexRoute,
  UnauthorizedIndexRoute: UnauthorizedIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  No_orgIndexLazyRoute: No_orgIndexLazyRoute,
  Not_foundIndexLazyRoute: Not_foundIndexLazyRoute,
  StudiesStudyIdBroadscaleSamplesRoute: StudiesStudyIdBroadscaleSamplesRoute,
  StudiesStudyIdTauSamplesRoute: StudiesStudyIdTauSamplesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
